/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

type LogoProps = {
    className?: string;
    color?: string;
};

const Logo = ({ className, color }: LogoProps) => {
    const defaultColor = '#000';
    return (
        <div className={`${className}`}>
            <svg viewBox="0 0 616 616">
                <g fill="none" fillRule="evenodd">
                    <g fill={color ?? defaultColor} fillRule="nonzero">
                        {/* eslint-disable-next-line max-len */}
                        <path d="M554 387 308 519 61 387v34l247 131 247-131zM308 81 62 215l246 133 246-133L308 81Zm0 232-182-98 182-99 182 99-182 98Z" />
                        <path d="m308 254-72-39 72-39 72 39zm193 63v35L308 457 115 352v-35l193 105z" />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default Logo;
